<header class="py-3" style="background-color: #B72727;">
    <div style="padding-left: 10%; padding-right: 10%;">
        <a href="/">
            <img src="assets/logo-itp-blanco.png" alt="Logo ITP" width="150">
        </a>
    </div>
</header>